// Public portfolio copy is limited to features found in the project source.
// A missing image or URL is intentional until a suitable public asset exists.
const projects = [
  {
    id: 'louise-soares',
    name: 'Louise Soares',
    category: 'Site para cursos presenciais',
    kind: 'commercial',
    stage: 'Em prévia local',
    description: 'Um site para apresentar formações presenciais de estética e facilitar o primeiro contato.',
    problem: 'Reunir cursos, informações práticas e canais de contato em uma experiência clara.',
    solution: 'Site responsivo com catálogo de formações, galeria, dúvidas frequentes e localização.',
    value: 'Cursos, dúvidas e caminhos de contato ficam reunidos para quem está conhecendo a oferta.',
    capabilities: ['Catálogo de formações', 'Galeria e perguntas frequentes', 'Localização e contato'],
    technologies: ['React', 'TypeScript', 'Vite'],
    image: '/projects/louise-soares.webp',
    imageAlt: 'Página inicial do site Louise Soares, com chamada para formações presenciais e retrato da profissional.',
    imageCaption: 'Página inicial · captura local',
    demoUrl: null,
    repositoryUrl: null,
    featured: true,
  },
  {
    id: 'agendaflow',
    name: 'AgendaFlow',
    category: 'Sistema de agendamento',
    kind: 'demo',
    description: 'Um painel para organizar agendamentos, clientes e serviços em uma mesma rotina.',
    problem: 'Acompanhar horários e atendimentos quando as informações ficam dispersas.',
    solution: 'Sistema web com agenda, cadastro de clientes e serviços e visão administrativa.',
    value: 'A equipe consegue consultar agenda, clientes e serviços a partir de um mesmo painel.',
    capabilities: ['Agenda e disponibilidade', 'Clientes e serviços', 'Painel administrativo'],
    technologies: ['Java', 'Spring Boot', 'PostgreSQL'],
    image: '/projects/agendaflow.webp',
    imageAlt: 'Tela de acesso do AgendaFlow com campos de e-mail e senha.',
    imageCaption: 'Tela de acesso · prévia local',
    demoUrl: null,
    repositoryUrl: 'https://github.com/gabrielll21/agendaFlow',
    featured: false,
  },
  {
    id: 'autolanche',
    name: 'AutoLanche',
    category: 'Sistema de gestão',
    kind: 'demo',
    description: 'Gestão de ingredientes, produtos e vendas para uma operação de alimentação.',
    problem: 'Acompanhar estoque e vendas em controles separados dificulta a rotina.',
    solution: 'Sistema para registrar ingredientes, movimentações de estoque, produtos, vendas e relatórios.',
    value: 'Estoque e vendas podem ser acompanhados no mesmo fluxo de trabalho.',
    capabilities: ['Estoque de ingredientes', 'Produtos e vendas', 'Relatórios operacionais'],
    technologies: ['Java', 'Spring Boot', 'Thymeleaf'],
    image: '/projects/autolanche.webp',
    imageAlt: 'Tela administrativa do AutoLanche com indicadores zerados e atalhos da operação.',
    imageCaption: 'Painel sem dados · prévia local',
    demoUrl: null,
    repositoryUrl: 'https://github.com/gabrielll21/autopecas-system',
    featured: false,
  },
  {
    id: 'mais-rs',
    name: 'Mais RS',
    category: 'Página de apresentação',
    kind: 'demo',
    description: 'Página para apresentar planos, comparar opções e encaminhar interessados ao WhatsApp.',
    problem: 'Explicar os planos e tornar o próximo passo de contato mais simples.',
    solution: 'Landing page com comparação de planos, perguntas frequentes e formulário que prepara a conversa no WhatsApp.',
    value: 'O interessado pode comparar opções antes de enviar sua solicitação.',
    capabilities: ['Apresentação de planos', 'Comparação de opções', 'Contato pelo WhatsApp'],
    technologies: ['React', 'Vite'],
    image: '/projects/mais-rs.webp',
    imageAlt: 'Página inicial do Mais RS com apresentação do guia comercial e chamada para conhecer os planos.',
    imageCaption: 'Página inicial · captura local',
    demoUrl: null,
    repositoryUrl: null,
    featured: false,
  },
  {
    id: 'karise-estetica',
    name: 'Karise Estética',
    category: 'Gestão de atendimentos',
    kind: 'demo',
    description: 'Sistema para organizar atendimentos de estética, profissionais e serviços.',
    problem: 'Concentrar a agenda e os cadastros necessários à rotina de atendimento.',
    solution: 'Painel com gestão de clientes, profissionais, serviços, agendamentos e calendário.',
    value: 'Agenda e cadastros ficam acessíveis na rotina de atendimento.',
    capabilities: ['Agenda e calendário', 'Clientes e profissionais', 'Cadastro de serviços'],
    technologies: ['Java', 'Spring Boot', 'Thymeleaf'],
    image: '/projects/karise-estetica.webp',
    imageAlt: 'Painel da Karise Estética com atalhos de agenda, clientes, serviços e calendário sem eventos.',
    imageCaption: 'Painel sem dados · prévia local',
    demoUrl: null,
    repositoryUrl: 'https://github.com/gabrielll21/sistemaAgendamentoClinica',
    featured: false,
  },
];

export default projects;
